export default "__VITE_ASSET__1963ba41__"